<template>
  <div class="slds-context-bar">
    <div class="slds-context-bar__primary">
      <div class="slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click slds-no-hover">
        <span class="slds-context-bar__label-action slds-context-bar__app-name">
          <span class="slds-truncate" title="Analysis Magic">Analysis Magic</span>
        </span>
      </div>
    </div>
    <nav class="slds-context-bar__secondary" role="navigation">
      <ul class="slds-grid">
        <router-link to="/CampaignAnalysis" v-slot="{ href, route, navigate, isActive}" v-if="$auth.isAuthenticated">
          <li :class="[isActive && 'slds-is-active', 'slds-context-bar__label-action']">
            <a :href="href" @click="navigate"><span class="slds-truncate" title="Analysis">Analysis</span></a>
          </li>
        </router-link>
        <router-link to="/Dashboard" v-slot="{ href, route, navigate, isActive}" v-if="$auth.isAuthenticated">
          <li :class="[isActive && 'slds-is-active', 'slds-context-bar__label-action']">
            <a :href="href" @click="navigate"><span class="slds-truncate" title="Dashboard">Dashboard</span></a>
          </li>
        </router-link>
        <router-link :to="{ name: 'DonorReport', params: { isLanded:true}}" v-slot="{ href, route, navigate, isActive}" v-if="$auth.isAuthenticated">
          <li :class="[isActive && 'slds-is-active', 'slds-context-bar__label-action']">
            <a :href="href" @click="navigate"><span class="slds-truncate" title="Donor">Donor Analysis</span></a>
          </li>
        </router-link>
      </ul>
    </nav>
    <div class="slds-context-bar__item slds-p-right_medium">
      <div class="slds-context-bar__item slds-col_bump-left slds-has-success" v-if="!$auth.isAuthenticated && !$auth.loading">
          <a id="qsLoginBtn" class="slds-context-bar__label-action" @click.prevent="login">Login</a>
        </div>
        <div class="slds-context-bar__item slds-col_bump-left" v-if="$auth.isAuthenticated">
          <a id="qsLogoutBtn" href="#" class="slds-context-bar__label-action" @click.prevent="logout">Log out</a>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  methods: {
    login() {
      this.$auth.loginWithRedirect();
    },
    logout() {
      this.$auth.logout();
      this.$router.push({ path: "/" });
    }
  }
};
</script>